<div class="offcanvas-header">
  <h5><b>Edit:</b> {{ partner.name }}</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="offcanvasRef.dismiss()"
  ></button>
</div>

<div class="offcanvas-body">
  <form [formGroup]="form">
    <!-- Primary -->
    <div class="mb-3">
      <label class="form-label"
        >Primary Category <span class="text-danger">*</span></label
      >
      <select class="form-select" formControlName="category">
        <option
          *ngFor="let c of categories"
          [value]="c.key"
          [disabled]="form.get('secondaryCategory')?.value === c.key"
        >
          {{ c.value }}
        </option>
      </select>
    </div>

    <!-- Secondary -->
    <div class="mb-3">
      <label class="form-label">Secondary Category</label>
      <select class="form-select" formControlName="secondaryCategory">
        <option value="">— none —</option>
        <option
          *ngFor="let c of categories"
          [value]="c.key"
          [disabled]="form.get('category')?.value === c.key"
        >
          {{ c.value }}
        </option>
      </select>
    </div>

    <!-- Recommended -->
    <div class="form-check mb-3">
      <input
        class="form-check-input"
        type="checkbox"
        id="recommendedCheck"
        formControlName="recommended"
      />
      <label class="form-check-label" for="recommendedCheck">
        Recommend Provider
      </label>
    </div>

    <hr />

    <!-- Existing offers -->
    <div formArrayName="offers">
      <strong>Offers</strong>
      <div
        *ngFor="let group of offersFA.controls; let i = index"
        [formGroupName]="i"
        class="row g-2 align-items-center mb-2"
      >
        <!-- show the offer text as a read‑only input -->
        <div class="col-6">
          <input
            type="text"
            class="form-control form-control-sm"
            [value]="group.get('offer')?.value"
            readonly
          />
        </div>

        <!-- days selector -->
        <div class="col-4">
          <select class="form-select form-select-sm" formControlName="days">
            <option *ngFor="let e of expirationTimeList()" [value]="e.value">
              {{ e.label }}
            </option>
          </select>
        </div>

        <!-- delete button -->
        <div class="col-auto">
          <button
            type="button"
            class="btn btn-link btn-sm text-danger"
            (click)="removeOffer(i)"
          >
            <img src="../../assets/images/delete-icon.svg" alt="Delete" />
          </button>
        </div>
      </div>
    </div>

    <hr />

    <div class="mb-3">
      <strong>Add Offer</strong>
      <div class="row g-2 align-items-end">
        <div class="col-5">
          <select
            class="form-select form-select-sm"
            (change)="onSelectOfferChange($event)"
          >
            <option value="" disabled selected>Select Offer</option>
            <option *ngFor="let opt of offerList()" [value]="opt">
              {{ opt }}
            </option>
            <option value="other">Enter New Offer</option>
          </select>
        </div>

        <div class="col-5" *ngIf="offerOption === 'other'">
          <input
            class="form-control form-control-sm"
            formControlName="newOffer"
            placeholder="Offer description"
          />
        </div>

        <div class="col-4">
          <select class="form-select form-select-sm" formControlName="newDays">
            <option *ngFor="let e of expirationTimeList()" [value]="e.value">
              {{ e.label }}
            </option>
          </select>
        </div>

        <div class="col-auto">
          <button
            type="button"
            class="primaryBtn text-white"
            (click)="addOffer()"
            [disabled]="
              offerOption === 'other'
                ? form.get('newOffer')!.invalid
                : !offerOption
            "
          >
            <img
              src="assets/images/edit-plus-icon.svg"
              alt="Add"
              width="16"
              height="16"
              class="me-2"
            />
            Add
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="offcanvas-footer d-flex justify-content-end p-3">
  <button class="secondaryBtn me-2" (click)="offcanvasRef.dismiss()">
    Cancel
  </button>
  <button class="primaryBtn" (click)="save()">Save</button>
</div>
